// Describes different locations where paywall can be shown
export enum PaywallLocation {
  ADD_TALENT = 'add-talent', // Add new artist flow
  AUDITIONS = 'auditions', // Your Insights -> Your Auditions
  BILLBOARD = 'billboard', // casting billboard page
  CREDITS = 'credits', // Edit Profile -> Credits -> when attaching media to a credit
  CUSTOM_URL = 'custom-url', // Custom URL
  CUSTOM_URL_UPSELL = 'custom-url-upsell', // Custom URL upsell
  CUSTOMIZE_SUBMISSION_UPLOAD = 'customize-submission-upload', // Customize submission upload
  DEEPLINK = 'deeplink', // deeplink flow (marketing emails)
  EDIT_PROFILE_UPLOAD = 'edit-profile-upload', // Edit profile upload
  GLOBAL_NAV = 'global-nav', // global navigation bar
  HEADSHOTS_MONTHLY = 'headshots-monthly', // Headshots monthly upsell modal
  HEADSHOTS_FREE = 'headshots-free', // Headshots free and Essential upsell modal
  HEADSHOTS_TRIAL = 'headshots-trial', // Headshots trial upsell modal
  MEDIA_BANK = 'media-bank', // media bank
  MEDIA_LIBRARY = 'media-library', // Media library
  MEDIA_LIBRARY_UPLOAD = 'media-library-upload', // Media library upload
  MEDIA_REQUEST_UPLOAD = 'media-request-upload', // Media request upload
  MEMBERSHIP = 'membership', // membership and billing page
  MEMBERSHIP_EDIT = 'membership-edit', // membership and billing page edit
  OVERAGE_BANNER = 'overage-banner', // Overage banner
  OVERAGE_MODAL = 'overage-modal', // Overage Modal
  OVERAGE_UPSELL_MODAL = 'overage-upsell-modal',
  BILLBOARD_PROJECT_HEADER = 'billboard-project-header', // Project header
  PROFILE = 'profile', // profile page
  PROFILE_MEDIA = 'profile-media', // Profile edit media uploaders, audio reel, video reel
  ROLE_TRACKER = 'role-tracker', // Your Insights -> Role Tracker
  SKILLS = 'skills', // Edit Profile -> Edit Skills -> when attaching media to a skill
  SIGNUP = 'signup', // sign up flow
  SOCIAL_UPGRADE = 'social-upgrade', // Social upgrade modal
  SUBMISSION_MEDIA = 'submission-media', // Submission media
  SUBMISSION_PAGE = 'submission-page', // Submission page
  SUBMISSION_COMPLETION = 'submission-completion', // Submission completion page
  SUBMISSION_TEMPLATE = 'submission-template', // Submission template
  SUBMISSION_TRENDS = 'submission-trends', // Your Insights -> Submission Trends
  TALENT_SCOUT = 'talent-scout', // Profile settings -> Representatives in Talent Scout
  THRIVE_UPSELL = 'thrive-upsell', // thrive upsell modal on billing and membership page
  DISCOUNT_MODAL = 'discount-modal', // Special discount modal
  ACTIVE_CARDLESS_TRIAL_MODAL = 'active-cardless-trial-modal', // Modal displayed when the talent has an active cardless trial
  EXPIRED_CARDLESS_TRIAL_MODAL = 'expired-cardless-trial-modal', // Modal displayed when the talent has expired cardless trial
  UNKNOWN = 'unknown',
}

export enum BillingPath {
  UserRegistration = 'user_registration',
  UserAddArtist = 'user_add_artist',
  UserUpgrade = 'user_upgrade',
  UserRegistrationOpenCalls = 'user_registration_open_calls',
  UserSubmissionOpenCalls = 'user_submission_open_calls',
}

export const paywallLocationToBillingPath = (
  location: PaywallLocation,
  redirectToOpenCall = false
): BillingPath | null => {
  const registrationPaths = [PaywallLocation.SIGNUP];
  const addArtistPaths = [PaywallLocation.ADD_TALENT];
  const upgradePaths = [
    PaywallLocation.MEMBERSHIP,
    PaywallLocation.THRIVE_UPSELL,
    PaywallLocation.MEMBERSHIP_EDIT,
    PaywallLocation.BILLBOARD,
    PaywallLocation.PROFILE,
    PaywallLocation.PROFILE_MEDIA,
    PaywallLocation.GLOBAL_NAV,
    PaywallLocation.HEADSHOTS_FREE,
    PaywallLocation.HEADSHOTS_TRIAL,
    PaywallLocation.HEADSHOTS_MONTHLY,
    PaywallLocation.MEDIA_BANK,
    PaywallLocation.AUDITIONS,
    PaywallLocation.SUBMISSION_TRENDS,
    PaywallLocation.TALENT_SCOUT,
    PaywallLocation.DEEPLINK,
    PaywallLocation.ROLE_TRACKER,
    PaywallLocation.MEDIA_LIBRARY,
    PaywallLocation.MEDIA_LIBRARY_UPLOAD,
    PaywallLocation.EDIT_PROFILE_UPLOAD,
    PaywallLocation.MEDIA_REQUEST_UPLOAD,
    PaywallLocation.CUSTOMIZE_SUBMISSION_UPLOAD,
    PaywallLocation.OVERAGE_BANNER,
    PaywallLocation.OVERAGE_MODAL,
    PaywallLocation.OVERAGE_UPSELL_MODAL,
    PaywallLocation.CUSTOM_URL,
    PaywallLocation.CUSTOM_URL_UPSELL,
    PaywallLocation.SUBMISSION_TEMPLATE,
    PaywallLocation.DISCOUNT_MODAL,
    PaywallLocation.SUBMISSION_MEDIA,
    PaywallLocation.SOCIAL_UPGRADE,
    PaywallLocation.BILLBOARD_PROJECT_HEADER,
    PaywallLocation.ACTIVE_CARDLESS_TRIAL_MODAL,
    PaywallLocation.EXPIRED_CARDLESS_TRIAL_MODAL,
  ];
  const submissionPaths = [PaywallLocation.SUBMISSION_COMPLETION];

  if (redirectToOpenCall && registrationPaths.includes(location)) return BillingPath.UserRegistrationOpenCalls;
  if (submissionPaths.includes(location)) return BillingPath.UserSubmissionOpenCalls;
  if (registrationPaths.includes(location)) return BillingPath.UserRegistration;
  if (addArtistPaths.includes(location)) return BillingPath.UserAddArtist;
  if (upgradePaths.includes(location)) return BillingPath.UserUpgrade;
  return null;
};
